var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.88 19.92h-30a1 1 0 1 1 0-2h30a1 1 0 0 1 0 2",
    className: "clr-i-outline clr-i-outline-path-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.27 15.86a12.9 12.9 0 0 1 1.29-.52a5.69 5.69 0 0 1 1.83-.34a3.18 3.18 0 0 1 2.75 1.11a4.44 4.44 0 0 1 .86 2.74v.49a13.83 13.83 0 0 0-4.29-.74a6.19 6.19 0 0 0-2.59.54a5 5 0 0 0-1.31.86h10.07v-1.15a5.67 5.67 0 0 0-1.37-4a5.16 5.16 0 0 0-4-1.49a10 10 0 0 0-3.91.88a.87.87 0 0 0-.44 1.18a.84.84 0 0 0 1.11.44",
    className: "clr-i-outline clr-i-outline-path-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 20a5.94 5.94 0 0 1 .54-2.31a4.35 4.35 0 0 1 1.58-1.83a4.27 4.27 0 0 1 4.59 0a4.47 4.47 0 0 1 1.57 1.83a6.12 6.12 0 0 1 .57 2.31h2a7.73 7.73 0 0 0-.78-3.19a6 6 0 0 0-2.18-2.45a5.74 5.74 0 0 0-3.1-.88a5.39 5.39 0 0 0-2.8.73a5.55 5.55 0 0 0-2 2.05V10a.87.87 0 0 0-.86-.86H20a.87.87 0 0 0-.86.86v10Z",
    className: "clr-i-outline clr-i-outline-path-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.67 22a5.61 5.61 0 0 1-.36 1.07a4.47 4.47 0 0 1-1.57 1.85a4.32 4.32 0 0 1-4.59 0a4.35 4.35 0 0 1-1.58-1.85A5.64 5.64 0 0 1 21.2 22h-2.11v4.13A.87.87 0 0 0 20 27h.2a.87.87 0 0 0 .86-.86v-1.63a5.58 5.58 0 0 0 2 2.06a5.48 5.48 0 0 0 2.8.72a5.66 5.66 0 0 0 3.1-.88A5.88 5.88 0 0 0 31.09 24a7.09 7.09 0 0 0 .64-2Z",
    className: "clr-i-outline clr-i-outline-path-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 22v.76a3.34 3.34 0 0 1-1.62 2a5.34 5.34 0 0 1-2.69.72a3.78 3.78 0 0 1-2.36-.7a2.24 2.24 0 0 1-.94-1.9a2.29 2.29 0 0 1 .2-.91H4.62a4 4 0 0 0-.13 1a3.83 3.83 0 0 0 1.35 3.06a5.15 5.15 0 0 0 3.47 1.17a6 6 0 0 0 2.69-.63a4.62 4.62 0 0 0 2-1.74V26a.86.86 0 0 0 .86.86H15a.86.86 0 0 0 .86-.86v-4Z",
    className: "clr-i-outline clr-i-outline-path-5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrike);
export default __webpack_public_path__ + "static/media/strike.7b539df4f1b1a49fe63adb549bad0d53.svg";
export { ForwardRef as ReactComponent };